import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "./api";
import { Course } from "../../Models/Course";

export const fetchAllCourses = createAsyncThunk(
  "items/fetchAll",
  async (_: void, thunkAPI) => {

    const raw = await api.listItems(); // fetch from API
    const data = raw.map((course: Course) => ({
      ...course,
      priceLoading: true,
    }));

    const idChunks = chunkCollections(data, 5);
    for (const ids of idChunks) {
      thunkAPI.dispatch(fetchAllCoursesChunks(ids));
    }

    return data;
  }
);

export const fetchAllCoursesChunks = createAsyncThunk(
  "items/fetchAllMetaChunk",
  async (courseIds: number[]) => {
    return api.listItemsMetaChunk(courseIds);
  }
);

// export const addItem = createAsyncThunk("items/add", async (data: Omit<Item, "id">) => {
//     return api.createItem(data);
// });

// export const saveItem = createAsyncThunk("items/save", async (partial: Item) => {
//     return api.updateItem(partial);
// });

// export const removeItem = createAsyncThunk("items/remove", async (id: string) => {
//     await api.deleteItem(id);
//     return id;
// });

const chunkCollections = (collections: Course[], chunkSize: number) =>
  Array.from({ length: Math.ceil(collections.length / chunkSize) }, (_, i) =>
    collections.slice(i * chunkSize, i * chunkSize + chunkSize).map((c) => c.id)
  );
